import {VisibilityRounded} from "@mui/icons-material";
import {Dialog, DialogContent, FormHelperText, FormLabel, Grid, IconButton, Stack} from "@mui/material";
import { get, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import FileUploader from "../../../../../../util/component/FileUploader";
import {ICustomerDataForm} from "../../../../models/models";
import useDialog from "../../../use-dialog/UseDialog";
import _ from "underscore";

const UploadDocument = ({currentDocument, required, curReferenceProp, ind, name, title, disabled}: any) => {
	const { t } = useTranslation(['network', 'translation']);
	const referenceProp = curReferenceProp + (ind !== undefined ? '[' + ind + ']' : '');
	const customerDataForm: any = useFormContext<ICustomerDataForm>();
	const errors: any = customerDataForm.formState.errors;

	const dialog = useDialog();

	const handleUpload = async (file: File) => {
		customerDataForm.setValue(`${referenceProp}.${name}`, file);
	}
	const handleRemove = () => {
		customerDataForm.setValue(`${referenceProp}.${name}`, null);
	}

	return (
        <Grid item xs={12} md={6}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
            >
                <FormLabel
                    required={required}
                    error={!!get(errors, `${referenceProp}.${name}`)}
                >
                    {title}
                </FormLabel>
                <IconButton
                    title={t('customerData.button.viewDocument')}
                    onClick={dialog.handleShow}
                    disabled={!currentDocument}
                >
                    <VisibilityRounded />
                </IconButton>
            </Stack>
            <Dialog
                open={dialog.open}
                onClose={dialog.handleClose}
                fullWidth
                maxWidth="lg"
            >
                <DialogContent>
                    <img
                        src={!!currentDocument?.size ? URL.createObjectURL(currentDocument) : undefined}
                        alt=""
                        width="100%"
                    />
                </DialogContent>
            </Dialog>
            <FileUploader
                uploadedFiles={!!currentDocument ? [currentDocument] : []}
                onUpload={handleUpload}
                onRemove={handleRemove}
                acceptedFiles={{'image/png': ['.png', '.jpeg', '.jpg']}}
                disabled={disabled}
            />
            {(curReferenceProp === 'mainDriver' && !!errors.mainDriver?.[name]) &&
                <FormHelperText error>
                    {t(errors.mainDriver[name].message)}
                </FormHelperText>
            }
            {(curReferenceProp === 'additionalDrivers' && !!errors.additionalDrivers?.[ind]?.[name]) &&
                <FormHelperText error>
                    {t(errors.additionalDrivers[ind].idDocFront.message)}
                </FormHelperText>
            }
        </Grid>
	);
}

export default UploadDocument;
